module.exports = __webpack_public_path__ + "static/media/img-wrapper.eaf82acf.png";